const currencyFormatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const compactFormatter = new Intl.NumberFormat('en-IN', {
  notation: 'compact',
  maximumFractionDigits: 0,
});

export function formatCurrency(value) {
  return currencyFormatter.format(Number(value || 0));
}

export function formatCompactNumber(value) {
  return compactFormatter.format(Number(value || 0));
}

export function formatFileSize(bytes) {
  const safeBytes = Number(bytes || 0);
  if (safeBytes < 1024) {
    return `${safeBytes} B`;
  }

  if (safeBytes < 1024 * 1024) {
    return `${(safeBytes / 1024).toFixed(1)} KB`;
  }

  return `${(safeBytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function toJsDate(value) {
  if (!value) {
    return null;
  }

  if (typeof value.toDate === 'function') {
    return value.toDate();
  }

  if (value instanceof Date) {
    return value;
  }

  return new Date(value);
}

export function formatDate(value) {
  const date = toJsDate(value);
  if (!date || Number.isNaN(date.getTime())) {
    return '--';
  }

  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(value) {
  const date = toJsDate(value);
  if (!date || Number.isNaN(date.getTime())) {
    return '--';
  }

  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getOrderDisplayId(order) {
  const raw = order?.orderId || order?.id || '';
  if (!raw) {
    return '--';
  }

  return raw.length > 10 ? raw.slice(-10).toUpperCase() : raw.toUpperCase();
}

export function getStatusMeta(status) {
  const normalizedStatus = status || 'paid';
  const meta = {
    paid: { label: 'Paid', tone: 'success' },
    simulated: { label: 'Paid (Demo)', tone: 'success' },
    printed: { label: 'Printed', tone: 'info' },
    delivered: { label: 'Delivered', tone: 'info' },
    cancelled: { label: 'Cancelled', tone: 'danger' },
    pending: { label: 'Pending', tone: 'neutral' },
  };

  return meta[normalizedStatus] || { label: normalizedStatus, tone: 'neutral' };
}
